import { Button } from '@mui/material';
import { DialogActionsWrapper, DialogContentWrapper, DialogTitleWrapper } from './styles';
import { ShowLoading } from '../../ShowLoading';
import { toastTypes } from '../../Toast/ToastOptions';
import { useDispatch } from 'react-redux';
import { addToast } from 'src/old/actions';
import { useTranslation } from 'react-i18next';
import { type Contract } from 'src/shared/types/contract';
import { type MutationDefinition } from '@reduxjs/toolkit/dist/query';
import { type UseMutation } from '@reduxjs/toolkit/dist/query/react/buildHooks';

type ContractsConfirmationModalProps = {
  payload: () => {
    contracts: Contract[];
    action: UseMutation<MutationDefinition<any, any, string, any, string>>;
    successMessage?: string;
    errorMessage?: string;
  };
  closeModal: () => void;
  header: string;
  Description: React.ElementType;
  loading?: boolean;
};

export const ContractsConfirmationModal = ({
  payload,
  closeModal,
  header,
  Description
}: ContractsConfirmationModalProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['common', 'actions']);
  const { contracts, action, ...rest } = payload();
  const [handleAction, { isLoading }] = action();

  const handleConfirm = async () => {
    try {
      await handleAction({ contracts }).unwrap();
      dispatch(
        addToast({
          ...toastTypes.success,
          defaultMessage: rest?.successMessage ?? t('employees.put.success', { ns: 'actions' })
        })
      );
    } catch (error) {
      dispatch(
        addToast({
          ...toastTypes.error,
          defaultMessage: rest?.errorMessage ?? t('employees.update.error', { ns: 'actions' })
        })
      );
    } finally {
      closeModal();
    }
  };

  return (
    <>
      <DialogTitleWrapper>{header}</DialogTitleWrapper>
      <DialogContentWrapper dividers>{isLoading ? <ShowLoading /> : <Description />}</DialogContentWrapper>
      <DialogActionsWrapper>
        <Button variant="text" color="primary" onClick={closeModal}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={handleConfirm}>
          {t('confirm')}
        </Button>
      </DialogActionsWrapper>
    </>
  );
};
